import { Pill } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { PLACEMENT_PERKS, PlacementPerk } from "../../../types/fetchPlacements.schema";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface HighlightSectionProps {
  signOnBonus: PlacementWithDetails["signOnBonus"];
  perks: NonNullable<PlacementWithDetails["perks"]>;
}

export function HighlightSection(props: HighlightSectionProps) {
  const { signOnBonus, perks } = props;

  return (
    <PlacementSectionTemplate title="Highlights" iconType="star">
      <Stack gap={2} direction="row" alignItems="flex-start" flexWrap="wrap">
        {isDefined(signOnBonus) && isDefined(signOnBonus.amountInMinorUnits) && (
          <Pill
            label={`Sign-On Bonus: ${formatCentsAsUsd(signOnBonus.amountInMinorUnits)}`}
            variant="filled"
            iconType="extra-pay"
          />
        )}
        {perks
          .filter(
            (perk) =>
              !(perk === PlacementPerk.SIGN_ON_BONUS && isDefined(signOnBonus?.amountInMinorUnits))
          )
          .map((perk) => {
            const perkOption = PLACEMENT_PERKS.find((option) => option.value === perk);

            return (
              <Pill
                key={perk}
                label={perkOption?.label ?? perk}
                variant="filled"
                iconType={perkOption?.icon}
              />
            );
          })}
      </Stack>
    </PlacementSectionTemplate>
  );
}
